export enum UpsaleCategoryEnum {
  Assistance = 'ASS',
  DiscountProtection = 'OZ',
  Glass = 'SZ',
  Greencard = 'ZK',
  Nnw = 'NNW',
  Tire = 'OP',
}
